import { Box, keyframes } from "@mui/material";

import { colors } from "@/Utils";

const textAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const CardLoader = (props) => {
  const { isLoading, style = {}, height, mrright, mrleft, children } = props;

  if (isLoading) {
    return (
      <Box
        className="spinner"
        sx={{
          backgroundColor: "transparent",
          width: "100%",
          height: height ? `${height}px` : "270px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "50px",
          marginRight: mrright ? `${mrright}px` : "0",
          marginLeft: mrleft ? `${mrleft}px` : "0",
          "& .spinner-text": {
            border: `5px solid ${colors.datePickerBg}`,
            borderRadius: "50%",
            borderTop: `7px solid ${colors.yellow}`,
            width: "70px",
            height: "70px",
            animation: `${textAnimation} 2s infinite`,
          },
        }}
        style={style}
      >
        <Box className="spinner-text" />
      </Box>
    );
  }
  return <>{children}</>;
};
